import React from 'react'
import { ButtonBase, makeStyles } from '@material-ui/core'

export type VendorView = 'directory' | 'analytics'

const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    pill: {
        borderRadius: 999,
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.secondary,
        padding: theme.spacing(0.5, 2),
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1.4,
        transition:
            'background-color 120ms ease, border-color 120ms ease, color 120ms ease',
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
            borderColor: theme.palette.grey[400],
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
        },
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
        },
    },
}))

interface Props {
    value: VendorView
    onChange: (value: VendorView) => void
}

export const VendorViewPills = ({ value, onChange }: Props) => {
    const classes = useStyles()

    return (
        <div className={classes.row} role="tablist" aria-label="Vendor view">
            <ButtonBase
                className={`${classes.pill} ${
                    value === 'directory' ? classes.selected : ''
                }`}
                onClick={() => onChange('directory')}
                aria-selected={value === 'directory'}
                role="tab"
            >
                Directory
            </ButtonBase>
            <ButtonBase
                className={`${classes.pill} ${
                    value === 'analytics' ? classes.selected : ''
                }`}
                onClick={() => onChange('analytics')}
                aria-selected={value === 'analytics'}
                role="tab"
            >
                Analytics
            </ButtonBase>
        </div>
    )
}
